import React, { memo } from 'react'

import StoreFront from '../../../components/redeem/StoreFront'

const StoreFrontWrapper = (props) => {
  return <StoreFront {...props} />
}

export default memo(StoreFrontWrapper)
